import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedApproaches } from './components/FailedApproaches';
import { MethodSection } from './components/MethodSection';
import { WhatYouGet } from './components/WhatYouGet';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { FooterSection } from './components/FooterSection';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n = (window.fbq = function (...args: any[]) {
        if ((n as any).callMethod) {
          ;
          (n as any).callMethod.apply(n, args);
        } else {
          ;
          (n as any).queue.push(args);
        }
      }) as any;
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '979586441263550');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white font-sans text-stone-900" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <div className="w-full h-px bg-amber-200/50" data-id="element-3"></div>
      <ProblemSection data-id="element-4" />
      <FailedApproaches data-id="element-5" />
      <MethodSection data-id="element-6" />
      <WhatYouGet data-id="element-7" />
      <AudienceSection data-id="element-8" />
      <HowItWorks data-id="element-9" />
      <ProofSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <OfferSection data-id="element-12" />
      <FooterSection data-id="element-13" />
    </div>;
}